import React from "react";
import { HtmlComponentView } from "./view";
import { styles } from "./styles";

export class HtmlComponent extends React.Component {
  render() {
    return <HtmlComponentView {...this.props} styles={styles} />;
  }
}
